<template>
  <!-- Barra de géneros del control de ventas (mockups "9 venta" y "10 venta").
       El badge rojo muestra cuántas reservas del género esperan una acción. -->
  <nav class="gt-bar" aria-label="Géneros">
    <template v-for="(g, i) in genres" :key="g.slug">
      <span v-if="i > 0" class="gt-sep" aria-hidden="true">|</span>
      <button
        type="button"
        class="gt-tab"
        :class="{ 'gt-tab-on': g.slug === activeSlug }"
        :aria-current="g.slug === activeSlug ? 'true' : undefined"
        @click="$emit('select', g.slug)"
      >
        {{ g.name.toUpperCase() }}
        <span v-if="counts[g.slug]" class="gt-badge">{{ counts[g.slug] }}</span>
      </button>
    </template>
  </nav>
</template>

<script>
export default {
  name: "GenreTabs",
  props: {
    genres: { type: Array, default: () => [] },
    // { [slug]: number } — pendientes por género.
    counts: { type: Object, default: () => ({}) },
    activeSlug: { type: String, default: "" },
  },
  emits: ["select"],
};
</script>

<style scoped>
.gt-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 10px;
  max-width: 900px;
  margin: 0 auto;
  padding: 16px 26px;
  background: rgba(8, 5, 5, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 18px;
}

.gt-sep {
  color: rgba(255, 255, 255, 0.25);
  font-size: 12px;
}

.gt-tab {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  color: var(--color-theater-text);
  font-family: var(--font-family-heading);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.9px;
  white-space: nowrap;
  transition: color 0.15s ease, opacity 0.15s ease;
}

.gt-tab:hover {
  opacity: 0.75;
}

.gt-tab-on {
  color: #e2495f;
}

.gt-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background: #c8102e;
  color: #fff;
  border-radius: 999px;
  font-size: 9.5px;
  font-weight: 800;
  line-height: 1;
}

@media (max-width: 700px) {
  .gt-sep {
    display: none;
  }
}
</style>
